import React from 'react';
import { observer, inject } from 'mobx-react';
import { withTranslation } from 'react-i18next';
import {
  withStyles,
  Grid,
  Button,
  Typography,
  Popover,
} from '@material-ui/core';
import * as Icons from '@material-ui/icons';
import Swal from 'sweetalert2';
import { clearLocalStorage } from '../../../utils/common';
import WarningForm from './Dialog/WarningForm';
import FixedEmergencyDeviceView from './Dialog/FixedEmergencyDeviceView';
import RouterView from './Dialog/RouterView';

class Router extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      tenantId: null,
      loading: false,
      dialogAddopen: false,
      dialogAddDeviceOpened: false,
      disable: false,
      fixedEmergencyDevices: [],
      devicesInMap: [],
      devicePoint: {
        id: null,
        mapId: null,
        position: {
          x: 0,
          y: 0,
        },
        place: null,
        name: null,
      },
      routerList: [],
      routers: [],
      routerPoint: {
        id: null,
        mapId: null,
        x: 0,
        y: 0,
        name: null,
        place: null,
        anchorEl: null, // Add anchorEl for popover
      },
      dialogWarningForm: {
        id: null,
        mapId: null,
        name: null,
        open: false,
      },
      offset: 0,
      limit: 100,
      tab: 0,
      searchText: '',
      typingTimeout: 0,
      category: null,
      headerTitle: '',
      subTitle: '',
    };
  }

  async componentDidMount() {
    const { mapId } = this.props.maps.toJS();
    const map = await this.props.maps._getMapById(mapId);
    if (map) {
      this.setState({ tenantId: map.tenantId });
    }

    this.initRouters(mapId);
    this.initFixedEmergencyDevices(mapId);
  }

  handleChangeTab = (tab) => {
    this.setState({
      tab,
    });
  };

  async initFixedEmergencyDevices(mapId) {
    const { tenantId } = this.state;
    const queryOption = {
      tenantIds: JSON.stringify([tenantId]),
      filterOutStatus: [],
      requiredMapIdNull: false,
      mapIds: JSON.stringify([mapId]),
    };
    let devices = await this.props.device.getFixedEmergencyDevices(queryOption);
    devices = (devices || []).map((d) => {
      let data = {};
      data.id = d.id;
      data.mapId = d.mapId;
      data.name = d.name;
      data.place = d.place;
      data.position = d.mapPosition;

      return data;
    });

    this.setState({ devicesInMap: devices });
  }

  handleAddDevice = async (e) => {
    const x = e.nativeEvent.offsetX;
    const y = e.nativeEvent.offsetY;
    this.setState({
      ...this.state,
      dialogAddDeviceOpened: true,
      devicePoint: {
        ...this.state.devicePoint,
        id: null,
        mapId: null,
        position: {
          x: x / 10,
          y: y / 10,
        },
        name: null,
      },
    });

    this.setFiexedEmergencyData();
  };

  handleDeviceChange = (e) => {
    const id = +e.target.value;
    const { mapId } = this.props.maps.toJS();
    const { fixedEmergencyDevices } = this.state;
    const device = fixedEmergencyDevices.data.find((val) => val.id === id);
    if (device) {
      this.setState({
        devicePoint: {
          ...this.state.devicePoint,
          id,
          mapId,
          place: device.place,
          name: device.name,
        },
        disable: true,
      });
    }
  };

  handleHoverDevice(id, task) {
    let devices = this.state.devicesInMap;
    if (task === 'clear') {
      (devices || []).map((val) => {
        val.hover = false;
        return val;
      });
    } else {
      (devices || []).map((val) => {
        if (val.id === id) {
          val.hover = true;
        } else {
          val.hover = false;
        }
        return val;
      });
    }
    this.setState({
      ...this.state,
      devicesInMap: devices,
    });
  }

  handleDeleteDevice = () => {
    const { dialogWarningForm } = this.state;
    const devices = [...this.state.devicesInMap];
    devices.forEach((d) => {
      if (d.id === dialogWarningForm.id) {
        d.mapId = null;
        d.position = null;
        d.name = null;
        d.place = null;
      }
    });
    this.setState({
      ...this.state,
      devicesInMap: devices,
    });

    const { fixedEmergencyDevices } = this.state;
    (fixedEmergencyDevices.data || []).forEach((device) => {
      if (device.id === dialogWarningForm.id) {
        device.mapId = null;
      }
    });
    this.handleCloseWarningForm();
  };

  handleCloseDeviceList = async () => {
    this.setState({
      searchText: '',
      dialogAddDeviceOpened: false,
      disable: false,
      fixedEmergencyDevices: [],
    });
    this.props.device.resetData();
  };

  handleSubmitDeviceList = async () => {
    const { devicePoint, devicesInMap } = this.state;
    let devices = devicesInMap.filter((d) => d.id !== devicePoint.id);
    devices.push(devicePoint);

    this.setState({
      dialogAddDeviceOpened: false,
      devicesInMap: devices,
      searchText: '',
      fixedEmergencyDevices: [],
      disable: false,
    });
    this.props.device.resetData();
  };

  handleSaveDevices = async () => {
    const { t } = this.props;
    const { devicesInMap } = this.state;
    try {
      const result = await this.props.device.assignDevicesToMap(devicesInMap);
      if (result.statusCode === 200) {
        const moduleStep = 3;
        this.props.wizard.setActiveStep(moduleStep);
        this.props.wizard.setActiveFlow('group');
        this.handleSetNavigation(moduleStep, 'module');
      }
    } catch (e) {
      if (e.statusCode === 401) {
        clearLocalStorage();
        window.location.href = '/login';
      } else {
        Swal.fire({
          html: `<h4>${t('failed_to_point_router')}`,
          type: 'error',
        });
      }
    }
  };

  handleSearchDevice = (task, value) => {
    if (this.state.typingTimeout) {
      clearTimeout(this.state.typingTimeout);
    }

    this.setState({
      searchText: value,
      typingTimeout: setTimeout(() => {
        this.props.device.setData('search', value, false);
        this.setFiexedEmergencyData();
      }, 1000),
    });
  };

  setFiexedEmergencyData = async () => {
    let { offset, search } = this.props.device.toJS();
    const queryOptionFreeDevice = {
      offset: offset,
      limit: this.state.limit,
      tenantIds: JSON.stringify([this.state.tenantId]),
      filterOutStatus: [],
      requiredMapIdNull: true,
      search: search,
    };
    const allDevices = await this.props.device.getFixedEmergencyDevices(queryOptionFreeDevice);
    if (allDevices && allDevices.data.length > 0) {
      allDevices.data.forEach((d) => {
        (this.state.devicesInMap || []).forEach((device) => {
          if (d.id === device.id) {
            d.mapId = device.mapId;
          }
        });
      });
    }
    this.setState({ fixedEmergencyDevices: allDevices });
  };

  handleChangeDevicePage = async (value) => {
    this.props.device.setData('offset', value * this.state.limit, false);
    await this.setFiexedEmergencyData();
  };

  async initRouters(mapId) {
    const routersInMap = await this.props.router.findByMapId(mapId);
    const routers = (routersInMap || []).map((val) => {
      let data = {};
      data.id = val.id;
      data.mapId = val.mapId;
      data.name = val.name;
      data.place = val.place;
      data.serial = val.serial;
      data.referenceNumber = val.referenceNumber;
      if (val.position) {
        let position = JSON.parse(val.position);
        data.x = position.x;
        data.y = position.y;
      } else {
        data.x = 0;
        data.y = 0;
      }
      data.anchorEl = null; // Add anchorEl for popover
      return data;
    });
    this.setState({ routers });
  }

  addRouter = async (e) => {
    const x = e.nativeEvent.offsetX;
    const y = e.nativeEvent.offsetY;
    this.setState({
      ...this.state,
      category: null,
      dialogAddopen: true,
      routerList: [],
      routerPoint: {
        ...this.state.routerPoint,
        id: null,
        x: x / 10,
        y: y / 10,
        name: null,
      },
    });

    await this.props.routerType.getCategory();
  };

  handleHoverRouter(id, task) {
    let routers = this.state.routers;
    if (task === 'clear') {
      routers.map((val) => {
        val.hover = false;
        return val;
      });
    } else {
      routers.map((val) => {
        if (val.id === id) {
          val.hover = true;
        } else {
          val.hover = false;
        }
        return val;
      });
    }
    this.setState({
      ...this.state,
      routers: routers,
    });
  }

  handlePopoverOpen = (event, id) => {
    let routers = this.state.routers;

    this.setState((prevState) => ({
      routers: prevState.routers.map((router) =>
        router.id === id ? { ...router, anchorEl: event.currentTarget } : router
      ),
    }));

    routers.map((val) => {
      if (val.id === id) {
        val.hover = true;
      } else {
        val.hover = false;
      }
      return val;
    });
  };

  handlePopoverClose = (id) => {
    let routers = this.state.routers;

    this.setState((prevState) => ({
      routers: prevState.routers.map((router) =>
        router.id === id ? { ...router, anchorEl: null } : router
      ),
    }));

    routers.map((val) => {
      val.hover = false;
      return val;
    });
  };

  handleClose = async () => {
    this.setState({
      dialogAddopen: false,
      disable: false,
      routerPoint: {
        id: null,
        mapId: null,
        x: 0,
        y: 0,
        name: null,
        place: null,
      },
    });

    this.props.router.resetData();
  };

  handleSubmit = async () => {
    const routerPoint = this.state.routerPoint;
    this.state.routers.push(routerPoint);
    this.setState({
      dialogAddopen: false,
      disable: false,
      routerPoint: {
        id: null,
        mapId: null,
        x: 0,
        y: 0,
        name: null,
        place: null,
      },
    });
    this.props.router.resetData();
  };

  handleSave = async () => {
    const { t } = this.props;
    const { mapId } = this.props.maps.toJS();
    try {
      const result = await this.props.maps.saveRouterPosition(this.state.routers, mapId);
      if (result.statusCode === 200) {
        const moduleStep = 3;
        this.props.wizard.setActiveStep(moduleStep);
        this.props.wizard.setActiveFlow('group');
        this.handleSetNavigation(moduleStep, 'module');
      }
    } catch (e) {
      if (e.statusCode === 401) {
        clearLocalStorage();
        window.location.href = '/login';
      } else {
        Swal.fire({
          html: `<h4>${t('failed_to_point_router')}`,
          type: 'error',
        });
      }
    }
  };

  onRouterChange = (e) => {
    const { mapId } = this.props.maps.toJS();
    const id = +e.target.value;
    const { routerList } = this.props.router.toJS();
    const router = routerList.data.find((val) => val.id === id);
    if (router) {
      this.setState({
        routerPoint: {
          ...this.state.routerPoint,
          id: id,
          mapId,
          place: router.place,
          name: router.name,
        },
        disable: true,
      });
    }
  };

  handleSearch = async (task, value) => {
    if (this.state.category) {
      this.props.router.setData(task, value, false);
      if (this.state.typingTimeout) {
        clearTimeout(this.state.typingTimeout);
      }

      this.setState({
        typingTimeout: setTimeout(() => {
          this.setRouterData();
        }, 1000),
      });
    }
  };

  handleSelectCategory = async (e) => {
    const value = e.target.value;
    this.setState({ category: value });
    if (value) {
      this.props.router.setData('limit', this.state.limit, false);
      this.props.router.setData('tenantIds', [this.state.tenantId], false);

      const { categories } = this.props.routerType.toJS();
      if (value === 'all') {
        const routerTypeIds = [];
        categories.forEach((c) => {
          if (c.routerTypes.length > 0) {
            c.routerTypes.forEach((r) => {
              routerTypeIds.push(r.id);
            });
          }
        });
        this.props.router.setData('typeIds', routerTypeIds, false);
      } else {
        const found = (categories || []).find((c) => c.category === value);
        if (found) {
          const routerTypeIds = found.routerTypes.map((r) => r.id);
          this.props.router.setData('typeIds', routerTypeIds, false);
        }
      }

      this.setRouterData();
    } else {
      this.props.router.resetData();
    }
  };

  setRouterData = async () => {
    const { offset, limit, search } = this.props.router.toJS();
    const routerList = await this.props.router.getRouterList(offset, limit, search, null, null, [this.state.tenantId]);
    if (routerList && routerList.data.length > 0) {
      routerList.data.forEach((r) => {
        (this.state.routers || []).forEach((router) => {
          if (r.id === router.id) {
            r.mapId = router.mapId;
          }
        });
      });
    }
    this.setState({ routerList });
  };

  handleChangeRowsPerPage = (value) => {
    this.props.router.setData('limit', value);
  };

  handleChangePage = (value) => {
    this.props.router.setData('offset', value * this.state.limit);
    this.setRouterData();
  };

  handleDelete = () => {
    const { dialogWarningForm } = this.state;
    this.props.router.setMapId(dialogWarningForm.id);
    const routers = this.state.routers;
    const filterRouter = routers.filter((val) => val.id !== dialogWarningForm.id);
    this.setState({
      ...this.state,
      routers: filterRouter,
    });

    const { routerList } = this.state;
    (routerList.data || []).forEach((router) => {
      if (router.id === dialogWarningForm.id) {
        router.mapId = null;
      }
    });

    this.handleCloseWarningForm();
  };

  handleOpendWarningForm = (value, task) => {
    const { t } = this.props;
    const name = value.place ? value.place : value.name;
    const subTitleRouter = t('wizard_router_delete_subtitle').replace('x', name);
    const subTitleDevice = t('wizard_device_delete_subtitle').replace('x', name);
    this.setState({
      headerTitle: task === 'router' ? t('wizard_router_delete') : t('wizard_device_delete'),
      subTitle: task === 'router' ? subTitleRouter : subTitleDevice,
      dialogWarningForm: {
        id: value.id,
        mapId: value.mapId,
        open: true,
        name,
      },
    });
  };

  handleCloseWarningForm = () => {
    this.setState({
      headerTitle: '',
      subTitle: '',
      dialogWarningForm: {
        ...this.state.dialogWarningForm,
        mapId: null,
        open: false,
      },
    });
  };

  goToPage = (data) => {
    this.handleSetNavigation(data.wizardStep, data.wizardPage);
    this.props.wizard.setActiveStep(data.wizardStep);
  };

  handleSetNavigation = (step, page) => {
    const { navigations } = this.props.wizard.toJS();

    navigations.forEach((nav) => {
      if (page !== 'map') {
        if (nav.wizardPage === 'unit') {
          nav.wizardName = 'wizard_step_unit';
        }
        if (nav.wizardPage === 'module') {
          nav.wizardName = 'wizard_step_module';
        }
      }
      if (nav.wizardPage === 'map') {
        nav.wizardName = 'wizard_map';
      }
    });
    const nav = navigations.filter((nav) => nav.wizardStep < step);
    this.props.wizard.setNavigation(nav);
    this.props.wizard.setRouterStep(false);
  };

  handleBack = () => {
    const mapStep = 4;
    this.handleSetNavigation(mapStep, 'map');

    const { t } = this.props;
    const { isChangeData } = this.state;
    if (isChangeData) {
      Swal.fire({
        html: `<h4>${t('wizard_ask_save_change')}`,
        type: 'warning',
        showCancelButton: true,
        cancelButtonText: `${t('cancel')}`,
        confirmButtonText: `${t('save')}`,
        reverseButtons: true,
        customClass: {
          container: 'my-swal',
        },
      }).then(async (result) => {
        if (result.value) {
          await this.handleSave();
        }
      });
    }
    this.props.wizard.setActiveStep(mapStep);
  };

  handleBackforDevice = () => {
    const mapStep = 4;
    this.handleSetNavigation(mapStep, 'map');

    const { t } = this.props;
    const { isChangeData } = this.state;
    if (isChangeData) {
      Swal.fire({
        html: `<h4>${t('wizard_ask_save_change')}`,
        type: 'warning',
        showCancelButton: true,
        cancelButtonText: `${t('cancel')}`,
        confirmButtonText: `${t('save')}`,
        reverseButtons: true,
        customClass: {
          container: 'my-swal',
        },
      }).then(async (result) => {
        if (result.value) {
          await this.handleSaveDevices();
        }
      });
    }
    this.props.wizard.setActiveStep(mapStep);
  };

  render() {
    const { classes, t } = this.props;
    const { devicesInMap, fixedEmergencyDevices, tab } = this.state;
    const { categories } = this.props.routerType.toJS();
    let { routerList, search } = this.props.router.toJS();
    const { map } = this.props.maps.toJS();
    const { navigations } = this.props.wizard.toJS();
    const count = routerList.data ? routerList.pagination.count : 0;
    const page = routerList.data ? routerList.pagination.page - 1 : 0;

    return (
      <div>
        <Grid container>
          <Grid container item sm={12}>
            {(navigations || []).map((nav, i) => (
              <div id={nav.wizardPage} className={classes.nav} key={i} onClick={() => this.goToPage(nav)}>
                {' '}
                {t(`${nav.wizardName}`)}
                {' > '}
              </div>
            ))}
            <div className={classes.activeNav}>{t('router')}</div>
          </Grid>
          <Grid container item sm={12}>
            <div className={classes.textHeader}>{t('wizard_router_of')}</div>
            <div className={classes.textHeaderPrimary}>{navigations[3].wizardName}</div>
          </Grid>
        </Grid>

        <Grid container item sm={12} style={{ marginTop: 10 }}>
          <div className={classes.textTitle}>{t('wizard_map_name')}: </div>
          <div className={classes.textName}>{map.name}</div>
        </Grid>

        <Grid container style={{ marginTop: 20 }}>
          <Button
            id='router-tab'
            variant='outlined'
            color='primary'
            onClick={() => this.handleChangeTab(0)}
            style={{
              marginRight: 10,
              borderRadius: 8,
              backgroundColor: tab === 0 ? '#E5F9F6' : '#FFFFFF',
            }}
          >
            <svg width='20' height='20' viewBox='0 0 20 20'>
              <use xlinkHref={`/images/map.svg#router`} />
            </svg>
            <div style={{ marginLeft: 5 }}>{t('router')}</div>
          </Button>
          <Button
            id='device-tab'
            variant='outlined'
            color='primary'
            onClick={() => this.handleChangeTab(1)}
            style={{
              borderRadius: 8,
              backgroundColor: tab === 1 ? '#E5F9F6' : '#FFFFFF',
            }}
          >
            <svg width='20' height='20' viewBox='0 0 20 20'>
              <use xlinkHref={`/images/map.svg#sos-device`} />
            </svg>
            <div style={{ marginLeft: 5 }}>{t('device')}</div>
          </Button>
        </Grid>

        {tab === 0 ? (
          <Grid container spacing={16}>
            {map.imgUrl && (
              <Grid item xs={12} className={classes.gridWrap}>
                <div
                  className={classes.boxImage}
                  style={{
                    background: `url(${map.imgUrl || ''}) center center no-repeat`,
                  }}
                  id='mapsposition'
                >
                  {(this.state.routers || []).map((val) => {
                    const open = Boolean(val.anchorEl); // Check if popover is open
                    return (
                      <div
                        style={{ textAlign: 'center' }}
                        key={val.id}
                        onClick={() => this.handleOpendWarningForm(val, 'router')}
                        onMouseEnter={(e) => this.handlePopoverOpen(e, val.id)}
                        onMouseLeave={() => this.handlePopoverClose(val.id)}
                      >
                        <div
                          className={classes.router}
                          style={{
                            left: `${val.x - 1.5}%`,
                            top: `${val.y - 1.5}%`,
                          }}
                        >
                          <Icons.Router className={classes.iconActivity} fontSize='large' />
                          {val.hover && <Icons.Clear className={classes.iconClaer} />}
                        </div>
                        <div
                          className={classes.nameRount}
                          style={{
                            left: `${val.x - 1.5}%`,
                            top: `${val.y - 1.5}%`,
                          }}
                        >
                          <label className='badge badge-primary'>{val.place ? val.place : val.name}</label>
                        </div>
                        <Popover
                          className={classes.popover}
                          classes={{
                            paper: classes.paper,
                          }}
                          id={val.id}
                          open={open}
                          anchorEl={val.anchorEl}
                          onClose={() => this.handlePopoverClose(val.id)}
                          anchorOrigin={{
                            vertical: 'bottom',
                            horizontal: 'center',
                          }}
                          transformOrigin={{
                            vertical: 'top',
                            horizontal: 'center',
                          }}
                        >
                          <Typography style={{ padding: 2 }}>{t('serial')}: {val.serial}</Typography>
                          <Typography style={{ padding: 2 }}>{t('reference_number')}: {val.referenceNumber}</Typography>
                        </Popover>
                      </div>
                    );
                  })}
                  <div className={classes.areaPoint} onClick={this.addRouter.bind(this)}></div>
                </div>
              </Grid>
            )}

            <Grid container item xs={12} style={{ marginTop: 20, justifyContent: 'space-between' }}>
              <Button
                id='back'
                variant='outlined'
                color='primary'
                onClick={this.handleBack}
                className={classes.btnPrimary}
              >
                {t('back')}
              </Button>
              <div style={{ display: 'flex' }}>
                <Button
                  id='save'
                  variant='contained'
                  color='primary'
                  className={classes.btnPrimary}
                  onClick={this.handleSave}
                >
                  {t('wizard_save_and_finish')}
                </Button>
              </div>
            </Grid>

            <RouterView
              open={this.state.dialogAddopen}
              routerList={this.state.routerList}
              routerPoint={this.state.routerPoint}
              limit={this.state.limit}
              disable={this.state.disable}
              category={this.state.category}
              categories={categories}
              search={search}
              count={count}
              page={page}
              handleClose={this.handleClose}
              handleChange={this.onRouterChange}
              handleSearch={this.handleSearch}
              handleSelect={this.handleSelectCategory}
              handleSubmit={this.handleSubmit}
              changePage={this.handleChangePage}
            />
          </Grid>
        ) : (
          <Grid container spacing={16}>
            {map.imgUrl && (
              <Grid item xs={12} className={classes.gridWrap}>
                <div
                  className={classes.boxImage}
                  style={{
                    background: `url(${map.imgUrl || ''}) center center no-repeat`,
                  }}
                  id='mapsposition'
                >
                  {(devicesInMap || []).map((val, i) => (
                    <div
                      style={{
                        textAlign: 'center',
                        display: val.position ? 'block' : 'none',
                      }}
                      key={i}
                      onClick={() => this.handleOpendWarningForm(val, 'device')}
                      onMouseOver={() => this.handleHoverDevice(val.id, 'hover')}
                      onMouseOut={() => this.handleHoverDevice(val.id, 'clear')}
                    >
                      <div
                        className={classes.sosDevice}
                        style={{
                          left: val.position ? `${val.position.x - 1.5}%` : 0,
                          top: val.position ? `${val.position.y - 1.5}%` : 0,
                        }}
                      >
                        <svg width='45' height='45' viewBox='0 0 84 83'>
                          <use xlinkHref={`/images/sos-v4.svg#fixed`} />
                        </svg>
                        {val.hover && <Icons.Clear className={classes.iconClaerDevice} />}
                      </div>
                      <div
                        className={classes.nameRount}
                        style={{
                          left: val.position ? `${val.position.x - 1.5}%` : 0,
                          top: val.position ? `${val.position.y - 1.5}%` : 0,
                        }}
                      >
                        <label className='badge badge-error-sos'>{val.place ? val.place : val.name}</label>
                      </div>
                    </div>
                  ))}
                  <div className={classes.areaPoint} onClick={this.handleAddDevice.bind(this)}></div>
                </div>
              </Grid>
            )}

            <Grid container style={{ marginTop: 20, justifyContent: 'space-between' }}>
              <Button
                id='back'
                variant='outlined'
                color='primary'
                onClick={this.handleBackforDevice}
                className={classes.btnPrimary}
              >
                {t('back')}
              </Button>
              <div style={{ display: 'flex' }}>
                <Button
                  id='save'
                  variant='contained'
                  color='primary'
                  className={classes.btnPrimary}
                  onClick={this.handleSaveDevices}
                >
                  {t('wizard_save_and_finish')}
                </Button>
              </div>
            </Grid>

            <FixedEmergencyDeviceView
              open={this.state.dialogAddDeviceOpened}
              devices={fixedEmergencyDevices}
              devicePoint={this.state.devicePoint}
              limit={this.state.limit}
              search={this.state.searchText}
              disable={this.state.disable}
              handleClose={this.handleCloseDeviceList}
              handleChange={this.handleDeviceChange}
              handleSearch={this.handleSearchDevice}
              handleSubmit={this.handleSubmitDeviceList}
              changePage={this.handleChangeDevicePage}
            />
          </Grid>
        )}

        <WarningForm
          open={this.state.dialogWarningForm.open}
          handleSubmitForm={tab === 0 ? this.handleDelete : this.handleDeleteDevice}
          handleCloseForm={this.handleCloseWarningForm}
          cancelButtonText={t('no')}
          confirmButtonText={t('confirm')}
          headerTitle={this.state.headerTitle}
          subTitle={this.state.subTitle}
        />
      </div>
    );
  }
}

const styles = (theme) => ({
  textHeader: {
    color: theme.palette.text.header,
    fontWeight: 500,
    fontSize: 30,
  },
  textHeaderPrimary: {
    color: theme.palette.primary.main,
    fontWeight: 500,
    fontSize: 30,
    marginLeft: 5,
  },
  textTitle: {
    color: theme.palette.text.header,
    fontWeight: 500,
    fontSize: 20,
  },
  textName: {
    fontWeight: 500,
    fontSize: 20,
    marginLeft: 5,
  },
  btnPrimary: {
    width: 180,
    borderRadius: '4px',
  },
  textField: {
    fontWeight: 400,
    fontSize: 16,
  },
  input: {
    color: theme.palette.text.primary,
    height: 40,
  },
  spaceTop: {
    marginTop: '10px',
  },
  gridWrap: {
    position: 'relative',
    overflowX: 'auto',
  },
  boxImage: {
    position: 'relative',
    width: '1015px',
    height: '1000px',
    backgroundSize: 'contain !important',
    border: '1px solid #D7D7D7',
    margin: '0 auto 0',
    marginTop: '20px',
  },
  iconActivity: {
    color: '#000',
  },
  router: {
    textAlign: 'center',
    width: '42px',
    height: '42px',
    background: 'rgba(3,149,136,0.8)',
    position: 'absolute',
    borderRadius: '50%',
    cursor: 'pointer',
    '&:hover, &:focus': {
      background: 'rgba(255,0,0,0.8)',
    },
  },
  sosDevice: {
    textAlign: 'center',
    position: 'absolute',
    borderRadius: '50%',
    cursor: 'pointer',
  },
  areaPoint: {
    width: '100%',
    height: ' 100%',
    cursor: 'copy',
  },
  buttons: {
    display: 'flex',
    justifyContent: 'flex-end',
  },
  button: {
    marginLeft: theme.spacing.unit * 1,
  },
  iconClaer: {
    color: 'black',
    marginTop: '-5px',
    marginLeft: '-2px',
    position: 'absolute',
  },
  iconClaerDevice: {
    color: 'black',
    marginTop: '-50px',
    marginLeft: '12px',
    position: 'absolute',
  },
  nameRount: {
    width: '300px',
    position: 'absolute',
    textAlign: 'center',
    marginTop: '48px',
    marginLeft: '-128px',
  },
  divider: {
    marginTop: '20px',
  },
  popover: {
    marginLeft: '10%',
    pointerEvents: 'none',
  },
  paper: {
    padding: theme.spacing.unit,
  },
  nav: {
    cursor: 'pointer',
    color: theme.palette.text.secondary,
    marginRight: 5,
  },
  activeNav: {
    cursor: 'pointer',
    color: theme.palette.primary.main,
  },
});

export const page = inject('wizard', 'tenant', 'maps', 'router', 'routerType', 'device')(observer(Router));
export const translation = withTranslation()(page);
export default withStyles(styles, { withTheme: true })(translation);
